<template>
  <div
    class="field-group"
    :class="{
      container: parent.Type !== 21
    }"
  >
    <template v-for="(field, index) in data.Body">
      <Field
        :data="field"
        :parent="data"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
        @field:delete="evtDelete"
        :key="'body_' + index"
      />
    </template>
    <template v-if="data.Fields">
      <form class="grid-form" v-if="data.Layout == 1">
        <fieldset>
          <legend>
            <span v-if="data.Text"><Localize :text="data.Text" /></span>
          </legend>
          <template v-for="(row, index) in data.Fields">
            <Field
              :data="row[0]"
              :parent="data"
              :sectionid="sectionid"
              :pageid="pageid"
              @field:isvalid="evtValid"
              @field:isfocused="evtFocused"
              @field:value="evtValue"
              @field:change="evtChange"
              @field:delete="evtDelete"
              :key="'row_' + index"
              v-if="
                row[0].Type == PreApproveMe.fieldTypes.BasicUserInformation ||
                  row[0].Type == PreApproveMe.fieldTypes.Address
              "
            />
            <div
              class="field-row-wrapper"
              data-row-span="4"
              :key="'row_' + index"
              v-else
            >
              <template v-for="(field, index) in row">
                <Field
                  :data="field"
                  :parent="data"
                  :sectionid="sectionid"
                  :pageid="pageid"
                  @field:isvalid="evtValid"
                  @field:isfocused="evtFocused"
                  @field:value="evtValue"
                  @field:change="evtChange"
                  @field:delete="evtDelete"
                  :key="'field_' + index"
                />
              </template>
            </div>
          </template>
        </fieldset>
      </form>
      <div v-else>
        <legend>
          <span v-if="data.Text"><Localize :text="data.Text" /></span>
        </legend>
        <template v-for="(row, row_index) in data.Fields">
          <div
            class="layout2-wrapper_2 field-row-wrapper"
            data-row-span="4"
            :data-layout="'L' + data.Layout"
            :key="'row_' + row_index"
          >
            <template v-for="(field, index) in row">
              <Field
                :data="field"
                :parent="data"
                :sectionid="sectionid"
                :pageid="pageid"
                @field:isvalid="evtValid"
                @field:isfocused="evtFocused"
                @field:value="evtValue"
                @field:change="evtChange"
                @field:delete="evtDelete"
                :key="'field_' + index"
              />
            </template>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'
import Localize from '@/components/Localize.vue'

export default {
  name: 'FieldGroup',
  components: {
    Localize
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe
    }
  },
  methods: {
    evtValid: function($event) {
      this.$emit('field:isvalid', $event)
    },
    evtFocused: function($event) {
      this.$emit('field:isfocused', $event)
    },
    evtValue: function($event) {
      this.$emit('field:value', $event)
    },
    evtChange: function($event) {
      this.$emit('field:change', $event)
    },
    evtDelete: function($event) {
      this.$emit('field:delete', $event)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.field-group {
  &.container {
    width: $card-container-width;
  }
}

.field-screen-body {
  &.container {
    .container {
      width: unset;
    }
  }
}
</style>
